import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Analogue from "./projects/analogue/Analogue";
import { Analytics } from "@vercel/analytics/react";
import Loupe from "./projects/loupe/Loupe";
import Multi from "./projects/multi-transactions/Multi";
import Echo from "./projects/echo/Echo";
import Access from "./projects/instant-access/Access";
import NineFin from "./projects/nine-fin/NineFin";
import Home from "./homepage/Home";
import PasswordGate from "./common/PasswordGate";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/analogue" index element={<Analogue />} />
        <Route
          path="/multi-transactions"
          element={
            <PasswordGate>
              <Multi />
            </PasswordGate>
          }
        />
        <Route path="/loupe" index element={<Loupe />} />
        <Route path="/echo" index element={<Echo />} />
        <Route
          path="/access"
          element={
            <PasswordGate>
              <Access />
            </PasswordGate>
          }
        />
        <Route
          path="/build"
          element={
            <PasswordGate>
              <NineFin />
            </PasswordGate>
          }
        />
        <Route path="/" element={<Home />} />
      </Routes>
      <Analytics />
    </div>
  );
}

export default App;
